
import Chartist from 'chartist';
import cr from './chartist-right';
import cp from './chartist-pointlabels';
import 'chartist-plugin-tooltips';
import * as tools from './../../../components/util/timeformat';
import _ from 'lodash';

cr(Chartist);
cp(Chartist);

function RealGrid(s)
{
	return s.effectivegrid > 0 ? s.effectivegrid : s.grid;
}

function OrderStart(s1, s2)
{
	if (s1.firstLap < s2.firstLap) return -1;
	if (s1.firstLap > s2.firstLap) return +1;
	
	return RealGrid(s1) - RealGrid(s2);
}

function OrderCarnumber(s1, s2)
{
	return RealGrid(s1) - RealGrid(s2);
}

function OrderEnd(s1, s2)
{
	if (s1.clonedlaps.length > s2.clonedlaps.length) return -1; // Cogemos las vueltas reales porque no tenemos en cuenta las añadidas para la grafica
	if (s1.clonedlaps.length < s2.clonedlaps.length) return +1;
	if (s1.rawtimesum + s1.startcorrection < s2.rawtimesum + s2.startcorrection) return -1; // TODO: Aqui solo nos llega el tiempo final... habria que tener en cuenta el raw, sin las sanciones
	if (s1.rawtimesum + s1.startcorrection > s2.rawtimesum + s2.startcorrection) return +1; // TODO: Se puede calcular con el tiempo de la ultima vuelta restando la primera si no hay countfirstlap

	return RealGrid(s1) - RealGrid(s2);
}

export default function CreateChart(heatdata) {
	if (!heatdata || !heatdata.drivers)
		return;

	let start = [];
	let maxLaps = 0;

	// Clone drivers and laps as we are going to modify the first lap to fit in the graph
	let clonedDrivers = heatdata.drivers.slice(0);
	for (let i = 0; i < clonedDrivers.length; ++i)
	{
		let clone = clonedDrivers[i].lapsdetail.slice(0);
		clonedDrivers[i].clonedlaps = clone;

		let d = clonedDrivers[i];

		if (d.clonedlaps.length > maxLaps)
			maxLaps = d.clonedlaps.length;

		start.push({
			nick: d.nick,
			firstLap: d.clonedlaps.length > 0 ? d.clonedlaps[0].y : 99999,
			grid: RealGrid(d),
			discarded: d.discarded
		});

		// Se añade una vuelta en t=0 desde la posicion de salida en parrilla
		if (heatdata.countfirstlap === true)
			d.clonedlaps.splice(0, 0, {x: 0, y: RealGrid(d)});
		else
		{
			if (d.clonedlaps.length > 0) {
				// WARN: DON'T MODIFY directly because it modifies also de original object -> d.lapsdetail[0].x = d.startcorrection;
				let first = d.clonedlaps[0];
				d.clonedlaps.splice(0, 1);
				d.clonedlaps.splice(0, 0, {x:d.startcorrection, y:first.y, t:first.t});
			}
		}
	}

	if (heatdata.countfirstlap === true)
		start.sort(OrderCarnumber);
	else
		start.sort(OrderStart);

	//let end = heatdata.drivers.slice();
	clonedDrivers.sort(OrderEnd);
	
	let nDrivers = clonedDrivers.length;

	let timeTicks = [];
	if (heatdata.heatDuration <= 15 * 60000)
	{
		for (let i = 0; i < heatdata.heatDuration; i += 60000)
		{
			timeTicks.push(i);
		}
	}
	else if (heatdata.heatDuration <= 45 * 60000)
	{
		for (let i = 0; i < heatdata.heatDuration; i += 5 * 60000)
		{
			timeTicks.push(i);
		}
	}
	else
	{
		for (let i = 0; i < heatdata.heatDuration; i += 10 * 60000)
		{
			timeTicks.push(i);
		}
	}

	if (timeTicks[timeTicks.length - 1] < heatdata.heatDuration)
		timeTicks.push(heatdata.heatDuration);

	var options = {
		showPoint: true,
		lineSmooth: false, // Disable line smoothing
		height: clonedDrivers.length * 20,
		// X-Axis specific configuration
		axisX: {
			type: Chartist.FixedScaleAxis,
			low: 0,
			high: heatdata.maxDriverTime,
			showLabel: true,
			ticks: timeTicks,
			labelInterpolationFnc: function(value) {
				return tools.FormatClockTime(value);
			}
		},
		// Y-Axis specific configuration
		axisY: {
			type: Chartist.FixedScaleAxis,
			onlyInteger: true,
			showGrid: true,
			low: 0,
			high: clonedDrivers.length + 1,
			showLabel: false,
			divisor: clonedDrivers.length + 1
		},
		chartPadding: {
			top: 10,
			right: 90,
			bottom: 0,
			left: 50
		},
		plugins: [
			Chartist.plugins.ctAxisRight({
				axisY: {
					axisTitle: 'Goals',
					axisClass: 'ct-axis-title',
					offset: {
						x: 0,
						y: 0
					},
					textAnchor: 'middle',
					flipTitle: false,
					leftDrivers: start, //_.map(start, function(d) { return d.nick} ),
					rightDrivers: clonedDrivers //_.map(clonedDrivers, function(d) { return d.nick} ),
				}
			}),
			Chartist.plugins.ctPointLabels({
				textAnchor: 'middle',
				labelInterpolationFnc: function(value) {
					if (heatdata.countfirstlap === true)
						return (value == 0) ? "·" : value - 1;
					else
						return value;
				}
			}),
			Chartist.plugins.tooltip({
				currency: undefined, //accepts '£', '$', '€', etc.
				//e.g. 4000 => €4,000
				tooltipFnc: function(x) { return tools.FormatLapTime(x); }, //accepts function
				//build custom tooltip
				transformTooltipTextFnc: undefined, //function(x) { console.log(x); return "-" + x }, // accepts function
				// transform tooltip text
				class: 'chartist-everlaps-tooltip', // accecpts 'class1', 'class1 class2', etc.
				//adds class(es) to tooltip wrapper
				anchorToPoint: false, //accepts true or false
				//tooltips do not follow mouse movement -- they are anchored to the point / bar.
				appendToBody: true //accepts true or false
				//appends tooltips to body instead of chart container
			})
		]
	};

	if (maxLaps > 30)
		options.width = maxLaps * 16;

	var data = {
		series: []
	};

	for (let i = 0; i < clonedDrivers.length; ++i)
	{
		data.series.push({
			//name: driversClone[i].nick,
			data: clonedDrivers[i].clonedlaps
		});
	}

	// Create a new line chart object where as first parameter we pass in a selector
	// that is resolving to our chart container element. The Second parameter
	// is the actual data object.
	/*new*/ Chartist.Line('.ct-chart', data, options)
	.on('data', function(context) {
		context.data.series = context.data.series.map(function(series) {
			return series.data.map(function(value) {
				return {x: value.x, y: nDrivers + 1 - value.y, meta: value.t};
			});
		});
	});
}


// WEBPACK FOOTER //
// ./client/app/frontend/results/chartist.js